/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import  {useContext, useEffect} from 'react';
import {getLocalStorage} from '../../core/localStorageService';
import {useNavigate} from 'react-router-dom';
import {AuthContext} from '../../providers/auth';

export default function Redirection() {
	const token = getLocalStorage('token') ? getLocalStorage('token') : '';
	const navigate = useNavigate();
	const {userInfo}: any = useContext(AuthContext);

	useEffect(() =>{
		if (!token) {
			navigate("/login");
		}
	}, [token, navigate])

	return (<div>Page Not Found</div>);
}
